function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import { equals } from 'ramda';
import LocaleKeys from '../../../../../locales/keys';
import { SUBSCRIPTION_TYPE } from '../../../../shared/constants/subscriptions.constants';
import { setEditRenewal, updateSubscription } from '../../../../../reducers/actions/customer.subscriptions.actions';
import { CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { CurrentSubscriptionSelector, IsUpdatingSubscriptionSelector, ModifyRenewalSubscriptionItemSelector, RenewalUnderEditSelector, SubscriptionFormErrorSelector } from '../../../../../reducers/selectors/customer.subscriptions.selectors';
var DEFAULT_RENEW_FORM_VIEW_MODEL = {
  isRenewTypeConfigurable: false,
  renew: false,
  terminationReason: 0,
  type: SUBSCRIPTION_TYPE.MANUAL
};
var RenewModalController = /*#__PURE__*/function () {
  function RenewModalController($ngRedux, uiNotificationService) {
    _classCallCheck(this, RenewModalController);
    this.$ngRedux = $ngRedux;
    this.localeKeys = LocaleKeys;
    this.notification = uiNotificationService;
    this.formLocaleKeys = {
      renewalType: this.localeKeys.SUBSCRIPTIONS.RENEWAL_TYPE,
      terminationReason: this.localeKeys.SUBSCRIPTIONS.TERMINATION_REASON
    };
    this.renewalDescriptor = {
      idField: function idField(field) {
        return (field || Number.isInteger(field)) && field.toString();
      }
    };
  }
  return _createClass(RenewModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        setEditRenewal: setEditRenewal,
        updateSubscription: updateSubscription
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          customerId: CurrentCustomerIdSelector(store),
          isUpdatingSubscription: IsUpdatingSubscriptionSelector(store),
          modifyRenewErrors: SubscriptionFormErrorSelector(store),
          renewFormViewModel: RenewalUnderEditSelector(store),
          subscription: CurrentSubscriptionSelector(store),
          modifyRenewalSubscriptionItem: ModifyRenewalSubscriptionItemSelector(store)
        };
      };
      this.renewFormViewModel = DEFAULT_RENEW_FORM_VIEW_MODEL;
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.setRecoverableViewModel();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.setEditRenewal(DEFAULT_RENEW_FORM_VIEW_MODEL);
      this.disconnectRedux();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.onClose()();
    }
  }, {
    key: "handleFormSubmit",
    value: function handleFormSubmit() {
      var _this2 = this;
      if (this.renewalForm.$valid) {
        var updatedSubscription = {
          Id: this.state.subscription.Id,
          RenewalType: this.renewFormViewModel.type,
          TerminationReason: this.renewFormViewModel.terminationReason
        };
        if (!this.state.modifyRenewalSubscriptionItem) {
          // Top Level Subscription's renewal is changed
          updatedSubscription.Renew = this.renewFormViewModel.renew;
        }
        if (this.state.subscription.Items.length > 1) {
          // Aligned Subscription's renewal or Individual Item of an Aligned Subscription is changed.
          if (this.renewFormViewModel.renew) {
            updatedSubscription.RenewItemIds = this.affectedSubscriptions.map(function (item) {
              return item.Id;
            });
          } else {
            updatedSubscription.RemoveItemIds = this.affectedSubscriptions.map(function (item) {
              return item.Id;
            });
          }
        }
        this.actions.updateSubscription(this.state.customerId, updatedSubscription).then(function (response) {
          var onSuccessCb = _this2.onSuccess();
          _this2.renewalForm.$setUntouched();
          _this2.notification.transientSuccess(i18n.translate(_this2.localeKeys.SUBSCRIPTIONS.UPDATE_SUCCESS));
          if (onSuccessCb) {
            onSuccessCb(response.Subscription);
          }
        });
      }
    }
  }, {
    key: "onRenewalToggle",
    value: function onRenewalToggle() {
      // we set the form to untouched on checkbox toggle to give the user the ability to fill in
      // the renewal options without errors displaying.
      this.renewFormViewModel.renew = !this.renewFormViewModel.renew;
      this.renewalForm.$setUntouched();
      this.saveRecoverableViewModel();
    }
  }, {
    key: "onRenewalChange",
    value: function onRenewalChange(option) {
      this.renewFormViewModel.type = option && option.id || null;
      this.saveRecoverableViewModel();
    }
  }, {
    key: "onTerminationChange",
    value: function onTerminationChange(option) {
      this.renewFormViewModel.terminationReason = option && option.id || null;
      this.saveRecoverableViewModel();
    }
  }, {
    key: "saveRecoverableViewModel",
    value: function saveRecoverableViewModel() {
      this.actions.setEditRenewal(this.renewFormViewModel);
    }
  }, {
    key: "setRecoverableViewModel",
    value: function setRecoverableViewModel() {
      var newViewModel = {
        isRenewTypeConfigurable: this.state.subscription.Policy && this.state.subscription.Policy.RenewTypeConfigurable,
        renew: this.state.subscription.Renew,
        terminationReason: this.state.subscription.TerminationReason,
        type: this.state.subscription.Type
      };
      if (this.state.modifyRenewalSubscriptionItem) {
        newViewModel.renew = equals('Yes', this.state.modifyRenewalSubscriptionItem.Renew);
      }
      this.actions.setEditRenewal(newViewModel);
      this.renewFormViewModel = newViewModel;
    }
  }, {
    key: "canChangeRenewalType",
    get: function get() {
      return this.renewFormViewModel && this.renewFormViewModel.isRenewTypeConfigurable && !this.requiresTerminationReason;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this.state.isUpdatingSubscription;
    }
  }, {
    key: "requiresTerminationReason",
    get: function get() {
      return this.renewFormViewModel && !this.renewFormViewModel.renew;
    }
  }, {
    key: "affectedSubscriptions",
    get: function get() {
      var _this3 = this;
      if (!this.state.modifyRenewalSubscriptionItem) {
        // All subscription Items are affected
        return this.state.subscription.Items;
      } else {
        return this.state.subscription.Items.filter(function (item) {
          return equals(item.Id, _this3.state.modifyRenewalSubscriptionItem.Id);
        });
      }
    }
  }]);
}();
export default {
  controller: RenewModalController,
  template: require('./renew.modal.html'),
  bindings: {
    onClose: '&',
    onSuccess: '&'
  }
};